import { useEndpointFetch } from '../network/useEndpointFetch';

export const useVerifyEmailFetch = () => {
  return useEndpointFetch<{ hash: string; email: string }, { resetToken: string | null }>('/im/user/email/verify', {
    withAuth: false,
  });
};
